import { type FC } from "react";
import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import * as styles from "./styles.css";

export const Information: FC = () => (
  <div className={styles.outer}>
    <p className={styles.informationText}>
      業界の市場調査を目的とし、口コミはリジョブおよび関連サイトへ匿名で掲載されます。
      <br />
      1企業につき1回、最大10企業まで投稿できます。
    </p>
    <div className={styles.boxOuter}>
      <GuidanceBox themeColor="pink">
        <div className={styles.desc}>
          <img
            className={styles.coffeeImage}
            src="/images/user_frontend/global/coffee.png"
            alt="コーヒーの画像"
          />
          <p className={styles.text}>
            アンケート回答者様へ<span className={styles.importantText}>カフェギフト500円分</span>
            をお渡しします。
          </p>
        </div>
      </GuidanceBox>
    </div>
  </div>
);
